import React, { useEffect, useState } from 'react';
import './quantity-input.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';

function QuantityInput({ initialValue, max, min, onQuantityChange, disabled }) {
    
    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ quantity, setQuantity ] = useState(initialValue || 0);
    const [ minimum, setMinimum ] = useState(0);

    useEffect(() => {
        onQuantityChange(quantity);
    }, [quantity])

    useEffect(() => {
        if (!min) return;
        setMinimum(min);
    }, [min])
  
    const handleIncrement = () => {
        if (quantity < max && !disabled) {
            setQuantity(quantity + 1);
        }
    };
  
    const handleDecrement = () => {
        if (quantity > minimum && !disabled) {
            setQuantity(quantity - 1);
        }
    };
  
    const handleChange = (event) => {
        const newQuantity = parseInt(event.target.value, 10);
        if (!isNaN(newQuantity) && newQuantity >= 1 && newQuantity <= max && !disabled) {
            setQuantity(newQuantity);
        }
    };
  
    return (
        <div className={`quantity-input-container ${screenSize}`}>
            <div className='quantity-input field small'>
                <button className='g-button small-btn' onClick={handleDecrement}>
                    <FontAwesomeIcon icon={faMinus} />
                </button>
                <input
                    type="number"
                    value={quantity}
                    onChange={handleChange}
                    min={minimum}
                    max={max}
                    disabled
                />
                <button className='g-button small-btn' onClick={handleIncrement}>
                    <FontAwesomeIcon icon={faPlus} />
                </button>
            </div>
        </div>
    );
}
  
  export default QuantityInput;